import { IQuoteLine } from "core/types/entities/IQuote";

const normalizeMultilineText = (value?: string) =>
  value?.replace(/\r\n/g, "\n").replace(/\r/g, "\n") ?? "";

const buildWorkOrderDescription = (quoteLines: IQuoteLine[] = []) =>
  quoteLines
    .filter((line) => line.recordType === "DescriptionOnlyLine")
    .map((line) => normalizeMultilineText(line.description))
    .filter((line) => line.length > 0)
    .join("\n");

export { normalizeMultilineText, buildWorkOrderDescription };
